import React, { useState, useLayoutEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import InaccessibleResources from "../../helpers/InaccessibleResources";
import GetKibanaDashboard from "../../components/Common/HelperComponents/KibanaDashboardComponents/GetKibanaDashboard";
import { ACCOUNT_DETAIL_FONT_SX } from "../../components/AccountDetailPolicy/accountDetailTypography";

const freeLicenseName = process.env.REACT_APP_FREE_ORGANIZATION_LICENSE;
const freeLicenses = [freeLicenseName];
const EMBED_PAGE_BODY_CLASS = "event-insight-embed-active";

const EVENT_INSIGHT_TABS_SX = {
  minHeight: 40,
  width: "100%",
  "& .MuiTabs-flexContainer": {
    width: "100%",
    alignItems: "center",
    gap: 0.25,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minHeight: 40,
    minWidth: "max-content",
    flexShrink: 0,
    flexGrow: { xs: 0, md: 1 },
    flexBasis: { xs: "auto", md: 0 },
    maxWidth: "none",
    px: { xs: 1, sm: 1.25 },
    fontSize: { xs: "0.75rem", md: "0.8125rem" },
    color: "#6b7280",
    fontWeight: 500,
    borderRadius: "8px",
    whiteSpace: "nowrap",
  },
  "& .MuiTab-root.Mui-selected": {
    color: "#111827 !important",
    fontWeight: 700,
    backgroundColor: "#ffffff",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#F98125",
    height: 3,
    borderRadius: "2px 2px 0 0",
  },
  "& .MuiTabs-scrollButtons": {
    color: "#64748b",
    "&.Mui-disabled": { opacity: 0.3 },
  },
};

const EventInsight = ({ licenseName, message }) => {
  const [activeTab, setActiveTab] = useState(() => {
    const tab = new URLSearchParams(window.location.search).get("tab");
    return tab === "event-insight" ? "event-insight" : "immediate-actions";
  });

  // Lock outer layout scroll before paint; cleanup restores normal scrolling on leave.
  useLayoutEffect(() => {
    document.body.classList.add(EMBED_PAGE_BODY_CLASS);
    return () => {
      document.body.classList.remove(EMBED_PAGE_BODY_CLASS);
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "event-insight":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return <GetKibanaDashboard dashboardKey={"Event_Insight_New"} />;
        }
        case "threat-detection":
          if (freeLicenses.includes(licenseName)) {
            return <InaccessibleResources message={message} />;
          } else {
            return <GetKibanaDashboard dashboardKey={"Event Detection POC"} />;
          }        
      case "mitre-attack":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return <GetKibanaDashboard dashboardKey={"MItre_event Insight"} />;
        }
      case "immediate-actions":
        if (freeLicenses.includes(licenseName)) {
          return <InaccessibleResources message={message} />;
        } else {
          return (
            <GetKibanaDashboard
              dashboardKey={"Immediate Action Required — Security Response"}
            />
          );
        }
      default:
        return null;
    }
  };

  return (
    <div className="event-insight-embed-page">
      <Box
        sx={{
          flexShrink: 0,
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
          px: 1.5,
          pt: 1.5,
          pb: 1,
          ...ACCOUNT_DETAIL_FONT_SX,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            backgroundColor: "#f3f4f6",
            borderRadius: "10px",
            px: 0.5,
            py: 0.5,
            overflow: "hidden",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={EVENT_INSIGHT_TABS_SX}
          >
            <Tab label="Risks" value="immediate-actions" />
            <Tab label="Cloud Event" value="event-insight" />
            <Tab label="Threat Detection" value="threat-detection" />
            <Tab label="Mitre Attack" value="mitre-attack" />
          </Tabs>
        </Box>
      </Box>
      <div className="event-insight-embed-body">{renderTabContent()}</div>
    </div>
  );
};

export default EventInsight;
